import React, { useState } from "react";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import { FaSearch } from "react-icons/fa";
import "./Cards.css";

const Cards = () => {
  const media = [
    { src: "assets/Images/Bathroom/bath23.mp4", alt: "video" },
    { src: "assets/Images/Bathroom/bath13.jpeg", alt: "image" },
  ];

  const [photoIndex, setPhotoIndex] = useState(0);
  const [isOpen, setIsOpen] = useState(false);

  const isVideo = (src) => src.endsWith(".mp4") || src.endsWith(".webm");

  const openLightbox = (index) => {
    setPhotoIndex(index);
    setIsOpen(true);
  };

  return (
    <div className="cards-container container">
      <div className="row g-3">
        {media.map((item, index) => (
          <div className="col-6" key={index}>
            <div className="card position-relative h-100">
              {isVideo(item.src) ? (
                <video className="img-fluid rounded" controls muted>
                  <source src={item.src} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              ) : (
                <img
                  src={item.src}
                  alt={item.alt}
                  className="img-fluid rounded"
                />
              )}
              <div className="overlay" onClick={() => openLightbox(index)}>
                <FaSearch className="icon" />
              </div>
            </div>
          </div>
        ))}
      </div>

      {isOpen && !isVideo(media[photoIndex].src) && (
        <Lightbox
          mainSrc={media[photoIndex].src}
          nextSrc={media[(photoIndex + 1) % media.length].src}
          prevSrc={media[(photoIndex + media.length - 1) % media.length].src}
          onCloseRequest={() => setIsOpen(false)}
          onMovePrevRequest={() =>
            setPhotoIndex((photoIndex + media.length - 1) % media.length)
          }
          onMoveNextRequest={() =>
            setPhotoIndex((photoIndex + 1) % media.length)
          }
        />
      )}

      {isOpen && isVideo(media[photoIndex].src) && (
        <div
          className="video-lightbox"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0,0,0,0.9)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1050,
          }}
        >
          <button
            onClick={() => setIsOpen(false)}
            style={{
              position: "absolute",
              top: "20px",
              right: "30px",
              background: "transparent",
              border: "none",
              fontSize: "2rem",
              color: "#fff",
              cursor: "pointer",
              zIndex: 1100,
            }}
            aria-label="Close video"
          >
            &times;
          </button>

          <button
            onClick={() =>
              setPhotoIndex((photoIndex + media.length - 1) % media.length)
            }
            style={{
              position: "absolute",
              left: "30px",
              top: "50%",
              transform: "translateY(-50%)",
              fontSize: "2rem",
              background: "transparent",
              border: "none",
              color: "#fff",
              cursor: "pointer",
              zIndex: 1100,
            }}
            aria-label="Previous"
          >
            &#10094;
          </button>

          <button
            onClick={() => setPhotoIndex((photoIndex + 1) % media.length)}
            style={{
              position: "absolute",
              right: "30px",
              top: "50%",
              transform: "translateY(-50%)",
              fontSize: "2rem",
              background: "transparent",
              border: "none",
              color: "#fff",
              cursor: "pointer",
              zIndex: 1100,
            }}
            aria-label="Next"
          >
            &#10095;
          </button>

          <video
            key={media[photoIndex].src}
            controls
            autoPlay
            style={{ maxHeight: "80vh", maxWidth: "90vw" }}
          >
            <source src={media[photoIndex].src} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
      )}
    </div>
  );
};

export default Cards;
